import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DirectionsBoatOutlined from '@mui/icons-material/DirectionsBoatOutlined';
import Ship from '../../Models/Interfaces/Ship';

interface Props {
  title: string;
  ship: Ship | null;
}

const ShipDetails: React.FC<Props> = ({ title, ship }) => (
  <Paper variant="outlined" sx={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ p: { xs: 2, sm: 2.5 }, bgcolor: 'background.default', borderBottom: 1, borderColor: 'divider' }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5, fontWeight: 600 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ width: 36, height: 36, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'primary.light', color: 'primary.main', borderRadius: 1 }}>
          <DirectionsBoatOutlined fontSize="small" />
        </Box>
        <Typography component="p" sx={{ minWidth: 0, fontSize: '1.0625rem', lineHeight: 1.5, overflowWrap: 'anywhere' }}>
          {ship ? (
            <>
              <Box component="strong" sx={{ mr: 1, fontWeight: 700, color: 'primary.main', fontVariantNumeric: 'tabular-nums' }}>{ship.shipNumber}</Box>
              {ship.name}{' '}
              <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>{ship.district?.split(' (')[0]}</Box>
            </>
          ) : 'Skip ekki valið'}
        </Typography>
      </Box>
    </Box>
    <Box component="dl" sx={{ m: 0, p: { xs: 2, sm: 2.5 }, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2.5, '& dd': { m: 0, overflowWrap: 'anywhere' } }}>
      <Box sx={{ gridColumn: '1 / -1' }}>
        <Typography component="dt" variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>Rekstraraðili</Typography>
        <Typography component="dd" variant="body2">
          {ship?.operatorName || '—'}
          {ship?.operatorId && <Box component="span" sx={{ display: 'block', color: 'text.secondary', fontVariantNumeric: 'tabular-nums' }}>{ship.operatorId}</Box>}
        </Typography>
      </Box>
      <Box>
        <Typography component="dt" variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>Heimahöfn</Typography>
        <Typography component="dd" variant="body2">{ship?.homePort || '—'}</Typography>
      </Box>
      <Box>
        <Typography component="dt" variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>Umdæmi</Typography>
        <Typography component="dd" variant="body2">{ship?.district || '—'}</Typography>
      </Box>
    </Box>
  </Paper>
);

export default ShipDetails;
